"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var pro_light_svg_icons_1 = require("@fortawesome/pro-light-svg-icons");
var pro_solid_svg_icons_1 = require("@fortawesome/pro-solid-svg-icons");
var material_1 = require("@mui/material");
var Icon_1 = __importDefault(require("../Icons/Icon"));
var StyledCheckbox = (0, material_1.styled)(material_1.Checkbox)(function (_a) {
    var theme = _a.theme;
    return ({
        display: 'flex',
        borderRadius: theme.shape.borderRadius,
        color: theme.palette.riverstone,
        padding: 0,
        svg: {
            height: theme.spacing(3),
            width: theme.spacing(2.25),
            color: 'inherit',
        },
    });
});
var Checkbox = function (_a) {
    var input = _a.input, props = __rest(_a, ["input"]);
    return ((0, jsx_runtime_1.jsx)(StyledCheckbox, __assign({ color: "azzurro" }, input, props, { checked: input.value, id: input.name, icon: (0, jsx_runtime_1.jsx)(Icon_1.default, { icon: pro_light_svg_icons_1.faSquare }), checkedIcon: (0, jsx_runtime_1.jsx)(Icon_1.default, { icon: pro_solid_svg_icons_1.faSquareCheck }) })));
};
exports.default = Checkbox;
